<template>
  <div class="dropdown topbar-item">
    <button 
      ref="dropdownButtonRef"
      aria-expanded="false" 
      aria-haspopup="true" 
      class="topbar-button position-relative" 
      type="button"
      @click="toggleDropdown"
    >
      <i class="ri-notification-3-line fs-24"></i>
      <span class="position-absolute topbar-badge fs-10 translate-middle badge bg-danger rounded-pill">
        {{ notifications.length }}
        <span class="visually-hidden">پیام های خوانده نشده</span>
      </span>
    </button>
    <div ref="dropdownMenuRef" class="dropdown-menu py-0 dropdown-lg dropdown-menu-end" :class="{ 'show': isOpen }">
      <div class="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
        <div class="row align-items-center">
          <div class="col">
            <h6 class="m-0 fs-16 fw-semibold">نوتیفیکیشن ها</h6>
          </div>
          <div class="col-auto">
            <a class="text-dark text-decoration-underline" href="javascript: void(0);" @click.prevent="clearAll">
              <small>حذف همه</small>
            </a>
          </div>
        </div>
      </div>
      <div data-simplebar="" style="max-height: 280px;" ref="scrollbarRef">
        <a 
          v-for="(notification, index) in notifications" 
          :key="index"
          class="dropdown-item py-3 border-bottom text-wrap" 
          href="javascript:void(0);"
        >
          <div class="d-flex">
            <div class="flex-shrink-0">
              <img 
                v-if="notification.avatar" 
                :alt="notification.name" 
                class="img-fluid me-2 avatar-sm rounded-circle" 
                :src="notification.avatar"
              />
              <div v-else class="avatar-sm me-2">
                <span 
                  :class="`avatar-title ${notification.iconClass || 'bg-soft-info text-info'} fs-20 rounded-circle`"
                >
                  <IconifyIcon v-if="notification.icon" :icon="notification.icon" />
                  <template v-else>{{ notification.initials || notification.name.charAt(0) }}</template>
                </span>
              </div>
            </div>
            <div class="flex-grow-1">
              <p class="mb-0" v-if="notification.message">
                <span class="fw-medium">{{ notification.name }}</span>
                {{ notification.message }}
              </p>
              <template v-else>
                <p class="mb-0 fw-semibold">{{ notification.name }}</p>
                <p class="mb-0 text-wrap">{{ notification.text }}</p>
              </template>
            </div>
          </div>
        </a>
      </div>
      <div class="text-center py-3">
        <a class="btn btn-primary btn-sm" href="javascript:void(0);">
          مشاهده همه اعلان ها
          <i class="ri-arrow-left-fill ms-1"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { Dropdown } from 'bootstrap'
import SimpleBar from 'simplebar'

export default {
  name: 'NotificationDropdown',
  props: {
    notifications: {
      type: Array,
      required: true
    }
  },
  setup() {
    const scrollbarRef = ref(null)
    const dropdownButtonRef = ref(null)
    const dropdownMenuRef = ref(null)
    const isOpen = ref(false)
    let dropdownInstance = null
    let simpleBarInstance = null

    const toggleDropdown = () => {
      if (!dropdownInstance && dropdownButtonRef.value) {
        dropdownInstance = new Dropdown(dropdownButtonRef.value)
      }
      if (dropdownInstance) {
        dropdownInstance.toggle()
      }
    }

    const handleClickOutside = (event) => {
      if (dropdownButtonRef.value && dropdownMenuRef.value) {
        const isClickInside = dropdownButtonRef.value.contains(event.target) || 
                             dropdownMenuRef.value.contains(event.target)
        if (!isClickInside && isOpen.value && dropdownInstance) {
          dropdownInstance.hide()
        }
      }
    }

    onMounted(() => {
      // Initialize Bootstrap Dropdown
      if (dropdownButtonRef.value) {
        dropdownInstance = new Dropdown(dropdownButtonRef.value, {
          autoClose: true
        })
        
        // Listen to dropdown events to update isOpen state
        dropdownButtonRef.value.addEventListener('show.bs.dropdown', () => {
          isOpen.value = true
          // Initialize SimpleBar when dropdown opens
          nextTick(() => {
            if (scrollbarRef.value && !simpleBarInstance) {
              simpleBarInstance = new SimpleBar(scrollbarRef.value)
            }
          })
        })
        dropdownButtonRef.value.addEventListener('hide.bs.dropdown', () => {
          isOpen.value = false
        })
        
        // Close dropdown when clicking outside
        document.addEventListener('click', handleClickOutside)
      }
    })

    onUnmounted(() => {
      // Remove click outside listener
      document.removeEventListener('click', handleClickOutside)
      
      // Dispose dropdown instance
      if (dropdownInstance) {
        dropdownInstance.dispose()
        dropdownInstance = null
      }
      // Dispose SimpleBar instance
      if (simpleBarInstance) {
        simpleBarInstance.unMount()
        simpleBarInstance = null
      }
    })

    const clearAll = () => {
      // Emit event to parent to clear notifications
      // For now, just log
      console.log('Clear all notifications')
    }

    return {
      scrollbarRef,
      dropdownButtonRef,
      dropdownMenuRef,
      isOpen,
      toggleDropdown,
      clearAll
    }
  }
}
</script>
